const LandUsePie = () => {
  const colors = [
    '#7A6A3A', // Grass, Shrub & Barren
    '#B71C1C', // Developed
    '#1B5E20', // Forest
    '#1565C0', // Wetlands & Open Water
    '#E65100', // Crops & Pasture
  ];

  new Pie({
    container: '#land-use-pie-chart',
    widthScale: 1,
    heightScale: 1,
    innerRadius: 80,
    resultField: 'value',
    categoryField: 'use',
    data: [
      { use: 'Grass, Shrub & Barren', value: 65 },
      { use: 'Developed', value: 23 },
      { use: 'Forest', value: 7 },
      { use: 'Wetlands & Open Water', value: 4 },
      { use: 'Crops & Pasture', value: 1 },
    ],
    color: d3.scaleOrdinal(colors),
  }).draw();
};
